import { Table } from '@app/modules/table/classes/table.class';
import { Paginator, SortDirection } from '@app/classes';
import { EmployeeBenefit } from '@app/models/payroll/employee/benefit.model';
import { AnalyticService, AuthService } from '@app/services';
import { EmployeeNameColumn } from './columns/employee-name.column';
import { FrequencyColumn } from './columns/frequency.column';
import { EffectiveAtColumn } from './columns/effective-at.column';
import { EmployeePremiumColumn } from './columns/employee-premium.column';
import { CompanyContributionColumn } from './columns/company-contribution.column';

export class EmployeeBenefitTable extends Table {
    sortDirection = SortDirection.ASC;
    links = false;
    bulkSelect = true;
    protected sortProperty = 'name';

    constructor(
        protected auth: AuthService,
        private analytics: AnalyticService,
        private benefitId: number
    ) {
        super(auth);
        this.boot();
    }

    setColumns(): void {
        const nameColumn = new EmployeeNameColumn();
        this.sortColumn = nameColumn;
        this.columns = [
            nameColumn,
            new EffectiveAtColumn(this.benefitId, this.auth.company.id, this.analytics),
            new EmployeePremiumColumn(this.benefitId, this.auth.company.id),
            new CompanyContributionColumn(this.benefitId, this.auth.company.id),
            new FrequencyColumn(this.benefitId, this.auth.company.id),
        ];
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            EmployeeBenefit.param('company', this.auth.company.id).param('benefit', this.benefitId).with('employee')
        );
    }
}
